import React, { useEffect, useState } from 'react';
import { Dialog } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const timeUnits = [
  { label: 'Minutes', value: 'minutes' },
  { label: 'Hours', value: 'hours' },
  { label: 'Days', value: 'days' },
  { label: 'Weeks', value: 'weeks' },
  { label: 'Months', value: 'months' },
];

const WaitTimeDrawer = ({ isOpen, onClose, onSave, initialData }) => {
  const [timeValue, setTimeValue] = useState(initialData?.value || 1);
  const [timeUnit, setTimeUnit] = useState(initialData?.unit || 'minutes');

  console.log(initialData,"intial")

  useEffect(() => {
    if(initialData){
      setTimeValue(initialData?.value || 1);
      setTimeUnit(initialData?.unit || 'minutes');
    }

  },[initialData])

  const handleSave = () => {
    onSave({
      value: timeValue,
      unit: timeUnit
    });
    onClose();
  };

  return (
    <Dialog
      as="div"
      className="fixed inset-0 overflow-hidden z-50"
      open={isOpen}
      onClose={onClose}
    >
      <div className="absolute inset-0 overflow-hidden">
        <Dialog.Overlay className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

        <div className="fixed inset-y-0 right-0 pl-10 max-w-full flex">
          <div className="relative w-96">
            <div className="h-full flex flex-col bg-white shadow-xl">
              {/* Header */}
              <div className="px-4 py-6 bg-gray-50 sm:px-6">
                <div className="flex items-start justify-between space-x-3">
                  <div className="space-y-1">
                    <Dialog.Title className="text-lg font-medium text-gray-900">
                      Wait Time Configuration
                    </Dialog.Title>
                    <p className="text-sm text-gray-500">
                      Set the duration to wait before proceeding
                    </p>
                  </div>
                  <div className="h-7 flex items-center">
                    <button
                      type="button"
                      className="text-gray-400 hover:text-gray-500"
                      onClick={onClose}
                    >
                      <span className="sr-only">Close panel</span>
                      <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>

              {/* Main content */}
              <div className="flex-1 flex flex-col justify-between">
                <div className="px-4 sm:px-6">
                  <div className="space-y-6 pt-6 pb-5">
                    <div>
                      <label className="block text-sm font-medium text-gray-900">
                        Wait Duration
                      </label>
                      <div className="mt-1 flex gap-4">
                        <input
                          type="number"
                          min="1"
                          value={timeValue}
                          onChange={(e) => setTimeValue(parseInt(e.target.value) || 1)}
                          className="block w-24 rounded-md border-gray-300 shadow-sm focus:border-[var(--brand-primary)] focus:ring-[var(--brand-primary)] sm:text-sm"
                        />
                        <select
                          value={timeUnit}
                          onChange={(e) => setTimeUnit(e.target.value)}
                          className="block w-full rounded-md border-gray-300 shadow-sm focus:border-[var(--brand-primary)] focus:ring-[var(--brand-primary)] sm:text-sm"
                        >
                          {timeUnits.map((unit) => (
                            <option key={unit.value} value={unit.value}>
                              {unit.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Action buttons */}
                <div className="flex-shrink-0 px-4 py-4 flex justify-end space-x-4 bg-gray-50">
                  <button
                    type="button"
                    className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] focus:ring-offset-2"
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="rounded-md border border-transparent bg-[var(--brand-primary)] py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-[#3599ab] focus:outline-none focus:ring-2 focus:ring-[var(--brand-primary)] focus:ring-offset-2"
                    onClick={handleSave}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default WaitTimeDrawer; 